export default

    class VehicleTypeController {

    constructor(resource) {
        this._resource = resource;
    }

    async create(vehicleType) {
        let result = null
        try {
            let response = await this._resource('typeVehicle').save(vehicleType)
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    getAllVehicleTypes() {
        return this._resource('typeVehicle')
            .get()
            .then(res => res.json())
            .catch(error => console.log(error))
    }

    delete(vehicleType) {
        return this._resource(`typeVehicle/${vehicleType.id}`)
            .delete(vehicleType)
            .then(res => res.json(), error => { throw new Error(error.body.message) })
    }

    async update(vehicleType) {
        let result = null
        try {
            let response = await this._resource(`typeVehicle/${vehicleType.id}`).update(vehicleType)
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    get(client_id) {
        return this._resource(`typeVehicle/client/${client_id}`)
            .get()
            .then(res => res.json())
            .catch(error => console.log(error))
    }
}